import { getNlsString } from '../nls/nlsRuntime'
import type { ChecklistType } from '../types/checklistBooks'

export const getChecklistBookName = (
  item?: { checklistType?: ChecklistType | string | null } | null,
): string => {
  switch (item?.checklistType) {
    case 'DAILY':
      return getNlsString('NLSChecklistKindDaily')
    case 'WEEKLY':
      return getNlsString('NLSChecklistKindWeekly')
    case 'INDIVIDUAL':
      return getNlsString('NLSChecklistKindIndividual')
    default:
      return getNlsString('NLSChecklistKindDefault')
  }
}
